import { css } from "../../styled-system/css"

export const LoadingOverlay = (props: { size?: 'sm' | 'md' }) => {

  const spinnerSize = props.size === 'sm' ? '24px' : '40px';

  return (
    <div className={css({
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
    })}>
      <div className={css({
        width: spinnerSize,
        height: spinnerSize,
        borderRadius: '50%',
        borderWidth: '4px',
        borderStyle: 'solid',
        borderColor: 'border.primary',
        borderTopColor: 'border.secondary',
        animation: 'spin 1s linear infinite',
      })} />
    </div>
  )
}